import { createContext, useContext } from "react";
const FieldActionsContext = createContext({});
function useFieldActions() {
  return useContext(FieldActionsContext);
}
export {
  FieldActionsContext,
  useFieldActions
};
//# sourceMappingURL=field-actions-context.js.map
